import React, { Component } from "react";
import Store from "../../content/Store";
import styles from "../../assets/css/modules/myprofile/change-bank-details.css";

import Content from "../../content/Content";
import { withRouter } from "react-router-dom";
import Scroll from "react-scroll";
import {
  changeBankAccount, deleteBankAccount
} from "../../actions/changebankaccount/ChangeBankAccountActions";
import {
  ButtonConfig,
  ValidationContent
} from "./../../constants/Constants";
import {
  updateNavigation
} from "../../actions/makeAClaim/MakeAClaimActions";
import { SortCodeFormatter, SortCodeToSixDigits, mask } from "../../helpers/SortCodeFormatter";

import { isValidAccountName, isValidAccountNo, isValidSortCode, isSpecialCharacters } from "../../validations/AccountNoValidation";

import { Paths } from "../../constants/UrlConstants";
import { connect } from "react-redux";
import MemberHelper from "../../helpers/MemberHelper";



const mapStateToProps = ({ policyReducer = {}, makeAClaimReducer }) => {
  const selectedPolicy = policyReducer.selectedPolicy;
  const currentMember = MemberHelper.getCurrentLoggedInMemberFromPolicy(selectedPolicy);


  return {
    navigationFromClaims: makeAClaimReducer?.navigationFromClaims,
    IsInternalView:
      policyReducer &&
      policyReducer.policyDetails &&
      policyReducer.policyDetails.IsInternalView,
    MembershipNumber:
      policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.MembershipNumber,
    MemberBank: currentMember.MemberBankDetail,
    clientId: currentMember && currentMember.ClientId
  };

};

export const updateAddressEventAction = "bank";

class ChangeBankDetailsInLine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      sortCode: "",
      sortCode1: this.props.MemberBank?.SortCode ? this.props.MemberBank?.SortCode.substring(0, 2) : "",
      sortCode2: this.props.MemberBank?.SortCode ? this.props.MemberBank?.SortCode.substring(2, 4) : "",
      sortCode3: this.props.MemberBank?.SortCode ? this.props.MemberBank?.SortCode.substring(4, 6) : "",
      AccountNo: this.props.MemberBank?.AccountNumber,
      name: "",
      AccountName: this.props.MemberBank?.AccountHolderName,
      deleteMode: false,
      scroll: false,
      validationErrors: [],
      bankUpdateSuccess: false,
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.validateBankModel = this.validateBankModel.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDeleteCancel = this.handleDeleteCancel.bind(this);
    this.onSubmitDelete = this.onSubmitDelete.bind(this);
  }




  componentWillUnmount() {
    this?.props?.updateNavigation(false);
  }
  componentDidMount() {
    console.log(this?.props?.navigationFromClaims);
    if (this?.props?.navigationFromClaims) {
      this.setState({
        editMode: true,
        validationErrors: []
      });
      this.props.HandleEdit();
    }


  }

  setGenericValidationError() {
    this.setState({
      validationErrors: [
        Store.ChangeBankDetailsInLine.ValidationErrors.GenericError
      ]
    });
    this.scrollToName(ValidationContent);
  }

  handleBankWizardError(errorMessage) {
    this.setState({
      validationErrors: [
        errorMessage?.Message
      ]
    });
    this.scrollToName(ValidationContent);
  }


  scrollToName = (name) => {
    console.log(name);
    Scroll.scroller.scrollTo(name, {
      duration: 750,
      smooth: true
    });
  };

  handleEdit(event) {
    event.preventDefault();
    this.setState({
      editMode: true,
      validationErrors: []
    });
    this.props.HandleEdit();

  }


  handleDelete(event) {
    event.preventDefault();
    this.setState({
      deleteMode: true,
      validationErrors: []
    });
    this.props.HandleEdit();
  }

  handleCancel(event) {

    event.preventDefault();
  
    if (!this.props.MemberBank?.AccountHolderName) {
      this.props.history.push({
        pathname: Paths.MyProfile,

      });
    }
    this?.props?.updateNavigation(false);
    this.setState({
      editMode: false,
      validationErrors: [],
      sortCode1: this.props.MemberBank?.SortCode ? this.props.MemberBank?.SortCode.substring(0, 2) : "",
      sortCode2: this.props.MemberBank?.SortCode ? this.props.MemberBank?.SortCode.substring(2, 4) : "",
      sortCode3: this.props.MemberBank?.SortCode ? this.props.MemberBank?.SortCode.substring(4, 6) : "",
      AccountNo: this.props.MemberBank?.AccountNumber,
      AccountName: this.props.MemberBank?.AccountHolderName,
    });

    this.props.CallBackParent();
  }

  handleDeleteCancel(event) {
    event.preventDefault();
    this.setState({
      deleteMode: false,
      validationErrors: []
    });
    this.props.CallBackParent();
  }


  onSubmit(event) {
    console.log("Submit");
    event.preventDefault();
    this.setState({ validationErrors: [], bankUpdateSuccess: false });
    let Operation = "";
    if (this.props.MemberBank?.AccountNumber) {
      Operation = Store.ChangeBankDetailsInLine.OpertaionUpdate;
    } else {
      Operation = Store.ChangeBankDetailsInLine.OpertaionInsert;
    }
    const bankModel = {
      sortCode: SortCodeToSixDigits(this.state.sortCode1, this.state.sortCode2, this.state.sortCode3),
      AccountName: this.state.AccountName,
      AccountNo: this.state.AccountNo,
      ClientId: this.props.clientId,
      Operation: Operation,
    };


    let errors = this.validateBankModel(bankModel);
    if (this.props.MemberBank?.AccountNumber === bankModel?.AccountNo && this.props.MemberBank?.AccountHolderName === bankModel?.AccountName && this.props.MemberBank?.SortCode === bankModel?.sortCode) {
      errors.push(Store.ChangeBankDetailsInLine.ValidationErrors.NoChanges);
    }
    if (errors.length > 0) {
      this.setState({ validationErrors: errors });
      this.scrollToName(ValidationContent);
      return;
    }
    this.props
      .changeBankAccount(this.props.MembershipNumber, bankModel)
      .then(() => {
        this.setState({ bankUpdateSuccess: true, editMode: false });
        this?.props?.updateNavigation(false);
        this.props.CallBackParent();
      })
      .catch((e) => {
        if (e?.response?.status === 400) {
          this.handleBankWizardError(e?.response?.data);
        } else {
          this.setGenericValidationError();
        }

      });
  }

  onSubmitDelete(event) {
    event.preventDefault();

    this.setState({
      validationErrors: [],
      bankUpdateSuccess: false
    });


    this.props
      .deleteBankAccount(this.props.MembershipNumber, this.props.clientId)
      .then(() => {
        this.setState({ bankUpdateSuccess: true, deleteMode: false });
        this.props.history.push({
          pathname: Paths.MyProfile,
        });

      })
      .catch(() => {
        this.setGenericValidationError();
      });
  }


  validateBankModel(bankModel = {}) {
    let errors = [];

    if (!bankModel.sortCode) {
      errors.push(Store.ChangeBankDetailsInLine.ValidationErrors.EmptySortCode);
    } else if (!isValidSortCode(bankModel.sortCode)) {
      errors.push(Store.ChangeBankDetailsInLine.ValidationErrors.InvalidSortCode);
    }

    if (!bankModel.AccountNo) {
      errors.push(Store.ChangeBankDetailsInLine.ValidationErrors.EmptyAccountNo);
    } else if (!isValidAccountNo(bankModel.AccountNo)) {
      errors.push(Store.ChangeBankDetailsInLine.ValidationErrors.InvalidAccountNo);
    }

    if (!bankModel.AccountName) {
      errors.push(Store.ChangeBankDetailsInLine.ValidationErrors.EmptyAccountName);
    } else
      if (isSpecialCharacters(bankModel.AccountName)) {
        errors.push(Store.ChangeBankDetailsInLine.ValidationErrors.InvalidAccountName);
      }

      else if (!isValidAccountName(bankModel.AccountName)) {
        errors.push(Store.ChangeBankDetailsInLine.ValidationErrors.InvalidAccountName);
      }
    return errors;
  }

  handleSortCodeChange = (e) => {
    const { maxLength, value, id } = e.target;
    const [fieldName, fieldIndex] = id.split("-");
    console.log(fieldName);
    this.setState({
      [e.target.name]: e.target.value
    });
    let fieldIntIndex = parseInt(fieldIndex, 10);

    // Check if no of char in field == maxlength
    if (value.length >= maxLength) {

      // It should not be last input field
      if (fieldIntIndex < 3) {

        // Get the next input field using it's name
        const nextfield = document.querySelector(
          `input[id=sortCode-${fieldIntIndex + 1}]`
        );
        // If found, focus the next field
        if (nextfield !== null) {
          nextfield.focus();
        }
      }
    }
  };


  render() {
  
    const nonModularButtonClasses = "btn btn-link";
    const nonModularFormClasses = "form-control form-control-sm";
    const axaMasking = "axa-mask";

    return (
      <div
        className={
          styles.changeBankdetails +
          (this.state.deleteMode
            ? " " + styles.changeBankdetailsFullWidth
            : "")
        }

      >

        <h5 className="bank-headline">
          <Content name={Store.ChangeBankDetailsInLine.BankTitle} />
        </h5>

        <div name={ValidationContent} />
        {this.props.MemberBank?.AccountHolderName && !this.state.editMode && !this?.props?.navigationFromClaims ? (
          <div className={styles.memberBankSection}>
            <ul className="list-unstyled membership-meta">
              <li>
                <strong>{Store.ChangeBankDetailsInLine.AccountNameTitle}</strong>
              </li>
              <li className="axa-mask">
                {this?.props?.IsInternalView ? mask(this.props.MemberBank?.AccountHolderName, 1) : this.props.MemberBank?.AccountHolderName}
                {this.state.bankUpdateSuccess ? <i className="icon-check-green float-right ml-2 mt-1" /> : null}
              </li>
              <li>
                <strong>{Store.ChangeBankDetailsInLine.AccountNoTitle}</strong>
              </li>
              <li className="axa-mask">
                {this?.props?.IsInternalView ? mask(this.props.MemberBank?.AccountNumber) : this.props.MemberBank?.AccountNumber}
              </li>
              <li>
                <strong>{Store.ChangeBankDetailsInLine.SortCodeTitle}</strong>
              </li>
              <li className="axa-mask">
                {this?.props?.IsInternalView ? mask(this.props.MemberBank?.SortCode, 2) : SortCodeFormatter(this.props.MemberBank?.SortCode)}

              </li>
            </ul>
          </div>)
          : null}
        {(!this.state.editMode && this.props.MemberBank?.AccountHolderName) &&
          !this.props.DisableEdit &&

          !this.state.deleteMode ? (

          <button
            id={"edit_bank"}
            onClick={this.handleEdit
            }
            className={`${nonModularButtonClasses} ${styles.btnStyles}`}
            disabled={this.props.IsInternalView ? true : false}
            style={this.props?.IsInternalView ? { color: "grey", cursor: "not-allowed", pointerEvents: "none" } : null}
          >
            <i className="icon-gear" />{" "}
            <Content name={Store.GeneralPages.ButtonEditText} />
          </button>
        ) : null}

        {this.props.MemberBank?.AccountHolderName &&
          !this.state.deleteMode &&
          !this.state.editMode &&
          !this.props.DisableEdit ? (
          <button
            onClick={this.handleDelete}
            className={`${nonModularButtonClasses} ${styles.btnStylesRight}`}
            disabled={this.props.IsInternalView ? true : false}
            style={this.props?.IsInternalView ? { color: "grey", cursor: "not-allowed", pointerEvents: "none" } : null}
          >
            <i className="icon-cross-orange" />{" "}
            <Content name={Store.GeneralPages.ButtonDeleteText} />
          </button>
        ) : null}


        {this.state.validationErrors.length > 0 ? (
          <div id="validationErrors" className="alert alert-danger" >
            <p className="alert-heading mb-1">
              <strong>
                <Content name={Store.GeneralPages.CorrectErrors} />
              </strong>
            </p>
            <ul>
              {this.state.validationErrors.map((error, index) => (
                <li key={index}>
                  <Content name={error} />
                </li>
              ))}
            </ul>
          </div>
        ) : null}


        {this.state.deleteMode ? (
          <div
            // id={"deleteSection_" + this.props.Telephone.Type}
            className={"input-tooltip " + styles.toolTip}
          >
            <p>
              <Content
                name={Store.ChangeBankDetailsInLine.DeleteConfirmTooltip}
              />
            </p>

            <button
              onClick={this.onSubmitDelete}
              className={`${nonModularButtonClasses} ${styles.btnStyles}`}
              style={{ marginTop: "10px", marginBottom: "10px" }}
            >
              <i className="icon-check-green" />{" "}
              <Content name={Store.GeneralPages.ButtonYesText} />
            </button>

            <button
              onClick={this.handleDeleteCancel}
              className={`${nonModularButtonClasses} ${styles.btnStylesRight}`}
              style={{ marginTop: "10px", marginBottom: "10px" }}
            >
              <i className="icon-cross-orange" />{" "}
              <Content name={Store.GeneralPages.ButtonNoText} />
            </button>
          </div>
        ) : null}

        {this.state.editMode || !this.props.MemberBank?.AccountHolderName || this.props?.navigationFromClaims ? (
          <form id="updateSection_bank" >
            <div className="fieldContainer">
              <div id="accountname" className="form-group">
                <label htmlFor="accountName">Account holder name</label>
                <input
                  className={`${nonModularFormClasses} ${axaMasking}`}
                  maxLength={34}
                  label="Account holder name"
                  type="text"
                  id={"AccountName"}
                  defaultValue={this.state.AccountName}
                  onChange={(e) =>
                    this.setState({
                      AccountName: e.target.value
                    })
                  }
                />
              </div>
              <div id="accountnumber" className="form-group">
                <label htmlFor="accountNumber">Account number</label>
                <input
                  className={`${nonModularFormClasses} ${axaMasking}`}
                  maxLength={8}
                  defaultValue={this.state.AccountNo}
                  type="text"
                  inputMode="numeric"
                  id={"AccountNumber"}
                  onChange={(e) =>
                    this.setState({
                      AccountNo: e.target.value
                    })
                  }
                />
              </div>
              <div id="sortCode" className="form-group">
                <label htmlFor="sortCode">Sort code</label>
                <div className={styles.inputRow}>


                  <div id="sortcode" name="sortcode" className="form-group-row-first">
                    <input
                      className={`${nonModularFormClasses} ${styles.inputWidth} ${axaMasking}`}
                      maxLength={2}
                      name="sortCode1"
                      inputMode="numeric"
                      type="text"
                      id="sortCode-1"
                      defaultValue={this.state.sortCode1}
                      onChange={this.handleSortCodeChange}
                    />

                  </div>
                  <div id="sortcode" name="sortcode" className="form-group-row-center">

                    <input
                      className={`${nonModularFormClasses} ${styles.inputWidth} ${axaMasking}`}
                      maxLength={2}
                      type="text"
                      name="sortCode2"
                      inputMode="numeric"
                      defaultValue={this.state.sortCode2}
                      id="sortCode-2"
                      onChange={this.handleSortCodeChange}
                    />

                  </div><div id="sortcode" name="sortcode" className="form-group-row-last">

                    <input
                      className={`${nonModularFormClasses} ${styles.inputWidth} ${axaMasking}`}
                      maxLength={2}
                      defaultValue={this.state.sortCode3}
                      name="sortCode3"
                      type="text"
                      id="sortCode-3"
                      inputMode="numeric"
                      onChange={this.handleSortCodeChange}
                    />

                  </div>
                </div>
              </div>

            </div>
            {/* <div name="ScrollContent" /> */}

            <button
              className={`${nonModularButtonClasses} ${styles.btnStyles}`}
              type="submit"
              onClick={this.onSubmit}
              id={ButtonConfig.ChangeBankDetailsSubmit}
              // style={{ marginTop: "30px" }}
              style={this?.props?.IsInternalView  ? { color: "grey", cursor: "not-allowed", pointerEvents: "none", marginTop: "30px" } : { marginTop: "30px" }}
              disabled={this.props.disabled}
            >
              <i className="icon-check-green" />{" "}
              <Content name={Store.GeneralPages.ButtonUpdateText} />
            </button>
            <button
              onClick={this.handleCancel}
              className={`${nonModularButtonClasses} ${styles.btnStylesRight}`}
              //style={{ marginTop: "30px" }}
              style={this?.props?.IsInternalView  ? { color: "grey", cursor: "not-allowed", pointerEvents: "none", marginTop: "30px" } : { marginTop: "30px" }}
            >
              <i className="icon-cross-orange" />
              <Content name={Store.GeneralPages.ButtonCancelText} />
            </button>

            {this.props.IsFormat2 ?
              <div className={styles.toolTip} >
                <p>
                  <Content
                    name={Store.ChangeBankDetailsInLine.CrestupdateNotification}
                  />
                </p>
              </div>
              : null}

          </form>
        ) : null}


      </div>
    );
  }
}



export default withRouter(connect(mapStateToProps, {
  changeBankAccount,
  deleteBankAccount,
  updateNavigation
})(ChangeBankDetailsInLine));